import { i as d, x as n, s as g } from "../../lit-element-6iugfgmM.js";
import { e as p } from "../../custom-element-wk-AooBb.js";
import { n as m } from "../../property-BWlAHqg_.js";
import { i as u } from "../../query-D8_rwLua.js";
import "../../query-assigned-elements-B8U94KLQ.js";
import "../../sp-button-fa52iiKJ.js";
import { Localize as b } from "../../lib/I18N.js";
import { LinkableCard as v } from "../../lib/LinkableCard.js";
import { s as f } from "../../shared-CxhTCuEO.js";
const y = { "tag-card.view-tag": "View tag" }, h = d`:host{--card-actions-padding: 10px;--card-overlay-background: rgba(0, 0, 0, .6);--tag-card-font-color: var(--spectrum-global-color-static-gray-50);--tag-card-font-size: 40px;--tag-card-background: linear-gradient(90deg, #085078 0%, #85d8ce 100%);background:var(--tag-card-background);height:100px}::slotted(*){color:var(--tag-card-font-color);font-size:var(--tag-card-font-size)}.browse-fonts-button{--spectrum-button-primary-m-border-color: var(--spectrum-global-color-static-gray-100);--spectrum-button-primary-m-border-color-hover: var(--spectrum-global-color-static-gray-50);--spectrum-button-primary-m-text-color: var(--spectrum-global-color-static-gray-100) }.browse-fonts-button:hover{color:var(--spectrum-global-color-static-gray-900)}.specimen{display:flex;align-items:center;justify-content:center;height:100%}`;
var w = Object.defineProperty, k = Object.getOwnPropertyDescriptor, i = (l, o, a, e) => {
  for (var s, t = e > 1 ? void 0 : e ? k(o, a) : o, c = l.length - 1; c >= 0; c--) (s = l[c]) && (t = (e ? s(o, a, t) : s(t)) || t);
  return e && t && w(o, a, t), t;
};
let r = class extends b(v(g), y) {
  static get styles() {
    return [f, h];
  }
  get focusElement() {
    return this.browseFontsButton;
  }
  connectedCallback() {
    super.connectedCallback();
  }
  render() {
    return this.renderLinkable(n`<div class="specimen"><slot></slot></div>${this.renderOverlay()}`);
  }
  renderActions() {
    return n`<div class="actions"><sp-button class="browse-fonts-button" static-color="white" treatment="outline">${this.t("tag-card.view-tag")}</sp-button></div>`;
  }
  renderOverlay() {
    return n`<div class="overlay">${this.renderActions()}</div>`;
  }
};
i([u(".browse-fonts-button")], r.prototype, "browseFontsButton", 2), i([m({ type: String })], r.prototype, "tag", 2), r = i([p("af-tag-card")], r);
const F = r;
export {
  F as default
};
//# sourceMappingURL=TagCard.js.map
